export default __webpack_public_path__ + "static/media/TV_CI.ee53f501.png";